import './modules/gallery';
import './modules/dynamicUpdates';
import './modules/dynamicDetections';
import './modules/customchart';
import { tns } from 'tiny-slider';

(function ($) {
  'use strict';

  Drupal.behaviors.lifewatchCarrousel = {
    attach: function (context, settings) {
      const elements = once('lifewatchCarrousel', '.c-carrousel-wrapper', context);
      elements.forEach(function (element) {
        var slider = tns({
          "container": ".c-carrousel-wrapper",
          "items": 3,
          "responsive": {
            "350": {
              "items": 1,
              "controls": true,
              "edgePadding": 30
            },
            "720": {
              "items": 2
            },
            "960": {
              "items": 3
            }
          },
          "slideBy": "page",
          "autoplay": true,
          "autoplayButtonOutput": false,
          "nav": true,
          "navPosition": 'bottom',
          "controlsText": ['', ''],
          "controlsPosition": 'top',
        });
      });
    }
  };

  Drupal.behaviors.lifewatchData = {
    attach: function (context, settings) {
      const elements = once('lifewatchData', '.c-data-services__outer', context);
      elements.forEach(function (element) {
        var slider = tns({
          "container": ".c-data-services__wrapper",
          "items": 3,
          "gutter": 20,
          "edgePadding": 30,
          "slideBy": "page",
          "autoplay": true,
          "autoplayButtonOutput": false,
          "nav": true,
          "navPosition": 'bottom',
          "controlsText": ['', ''],
          "controlsPosition": 'top',
          "responsive": {
            "350": {
              "items": 1,
              "controls": true,
            },
            "720": {
              "items": 1,
            },
            "960": {
              "items": 3,
            },
            "1140": {
              "items": 3,
            },
          },
        });
      });
    }
  };

  Drupal.behaviors.menuToggle = {
    attach: function(context){
      const elements = once('menuToggle', '.js-menu-toggle', context);
      elements.forEach(function (element) {
        $(element).on('click', function(e) {
          e.preventDefault();
          $('.menu--main ul.menu').slideToggle('fast');
        });
      });
    }
  };

  Drupal.behaviors.searchBlock = {
    attach: function(context){
      const elements = once('searchBlock', '.form-search', context);
      elements.forEach(function (element) {
        $(element).attr("placeholder", "Type your search request");
      });
    }
  };

  Drupal.behaviors.organismeToggle = {
    attach: function(context){
      const elements = once('organismeToggle', '.js_dropdown', context);
      elements.forEach(function (element) {
        $(element).on('click', function(e) {
          e.preventDefault();
          $('.view-organisms-of-interest').slideToggle('fast');
        });
      });
    }
  };

}(window.jQuery));
